// extracted by mini-css-extract-plugin
export default {"icon":"v2hYqlurfCflkjJh41ds-Q=="};